import { Attribution, SortBy, SortType } from 'types'

interface Params {
  endDate: string
  startDate: string
  limit: number
  offset: number
  attr: Attribution
  id: string
  sortBy?: SortBy
  sortType?: SortType
}

export const getOrganicTableData = ({
  endDate,
  startDate,
  limit,
  offset,
  attr,
  id,
  sortBy,
  sortType = 'DESC',
}: Params) => {
  let sortParamName

  if (sortBy === 'views') {
    sortParamName = `stats.views`
  } else if (attr === 'first' || attr === 'last') {
    sortParamName = `${attr}.${sortBy}`
  } else if (attr === 'linear' || attr === 'ai') {
    sortParamName = `${attr}_source.${sortBy}`
  }

  const sorting = sortBy ? `ORDER BY ${sortParamName} ${sortType}` : ''

  switch (attr) {
    case 'first':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(first.new_customers), SUM(first.leads), SUM(first.form_submits), SUM(first.total_orders), SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount), utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}' GROUP BY utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'last':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(last.new_customers), SUM(last.leads), SUM(last.form_submits), SUM(last.total_orders), SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount), utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}' GROUP BY utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'linear':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(linear_source.leads), SUM(linear_source.form_submits), SUM(linear_source.total_orders), SUM(linear_source.total_amount), SUM(linear_source.recurring_payments_amount), SUM(linear_source.orders_amount), utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}' GROUP BY utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'ai':
      return `SELECT SUM(stats.views), SUM(stats.new_visitors), SUM(stats.new_customers), SUM(ai_source.leads), SUM(ai_source.form_submits), SUM(ai_source.total_orders), SUM(ai_source.total_amount), SUM(ai_source.recurring_payments_amount), SUM(ai_source.orders_amount), utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}' GROUP BY utm_source.source_id, utm_source.utm_medium, utm_source.utm_content, utm_source.utm_campaign, utm_source.utm_source ${sorting} LIMIT ${limit} OFFSET ${offset}`
    default:
      return ''
  }
}
